import { motion } from "framer-motion";

export default function SmileArc({
  className = "",
  delay = 0,
  strokeWidth = 16,
  inView = false,
}) {
  const anim = inView
    ? {
        initial: { pathLength: 0 },
        whileInView: { pathLength: 1 },
        viewport: { once: true, margin: "-60px" },
      }
    : { initial: { pathLength: 0 }, animate: { pathLength: 1 } };

  return (
    <motion.svg
      viewBox="0 0 320 120"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <motion.path
        d="M28 24 C 76 108, 244 108, 292 24"
        stroke="#D2968C"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        {...anim}
        transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
      />
    </motion.svg>
  );
}
